import { gqlQuery } from '@hapana/shared/web/services/requests.service'

import {
  clientsQuery,
  clientQuery,
  equipmentAssignmentsByClientIdQuery,
} from './graphql/clients.queries.js'

export const getClients = gqlQuery({
  key: 'CLIENTS_DATA',
  query: clientsQuery,
})

export const getClient = gqlQuery({
  key: 'CLIENT_DATA',
  query: clientQuery,
})

export const getEquipmentAssignmentsByClientId = gqlQuery({
  key: 'EQUIPMENT_ASSIGNMENTS_BY_CLIENT_ID',
  query: equipmentAssignmentsByClientIdQuery,
})
